export default "/images/image-bottom-rest.jpeg?2e4720eb0c1e900266e61c20bc000dd3";